import type { ReactNode } from 'react'

interface LegalPageLayoutProps {
  title: string
  lastUpdatedLabel: string
  children: ReactNode
}

/**
 * Shared shell for the three legal pages (mentions légales, privacy policy,
 * cookie policy) — a narrow, readable text column consistent with the
 * article-reading pages elsewhere in the app, with a title and a localized
 * "last updated" line.
 */
export function LegalPageLayout({ title, lastUpdatedLabel, children }: LegalPageLayoutProps) {
  return (
    <div className="container mx-auto w-full max-w-3xl grow px-4 py-16">
      <h1 className="text-3xl font-serif font-bold">{title}</h1>
      <p className="mt-2 text-sm text-muted-foreground">{lastUpdatedLabel}</p>
      <div className="mt-8 flex flex-col gap-6 text-sm leading-relaxed text-foreground [&_h2]:mt-4 [&_h2]:font-serif [&_h2]:text-xl [&_h2]:font-semibold [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:flex [&_ul]:flex-col [&_ul]:gap-1 [&_a]:underline [&_a]:underline-offset-2 [&_a]:hover:text-primary">
        {children}
      </div>
    </div>
  )
}
